import type { OptionType } from '@/types/SM/formFields'
import type { TimeslotsStructureItemType } from '@/types/SM/viewTimeslots'

export const scheduleStatusOptions = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' }
] as OptionType[]

// TODO: Populate this from API. This is just a placeholder
export const WorkDivisionOptions = [
  {
    label: 'AM',
    value: 'AM'
  },
  {
    label: 'BF',
    value: 'BF'
  },
  {
    label: 'DT',
    value: 'DT'
  },
  {
    label: 'FR',
    value: 'FR'
  },
  {
    label: 'IP',
    value: 'IP'
  },
  {
    label: 'OP',
    value: 'OP'
  },
  {
    label: 'RS',
    value: 'RS'
  },
  {
    label: 'UC',
    value: 'UC'
  },
  {
    label: 'UE',
    value: 'UE'
  },
  {
    label: 'UF',
    value: 'UF'
  },
  {
    label: 'UI',
    value: 'UI'
  },
  {
    label: 'UN',
    value: 'UN'
  },
  {
    label: 'UP',
    value: 'UP'
  }
] as OptionType[]

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export const weekDayOptions = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' }
] as OptionType[]

export function weekdayNumberFromName (dayName: string) {
  return weekDays.indexOf(dayName.toLowerCase()) + 1
}

export function getSortedWeekdaysStructureItems (weekdays: TimeslotsStructureItemType[]) : TimeslotsStructureItemType[] {
  return weekdays.sort((a, b) => {
    return weekdayNumberFromName(a.weekDayKey) - weekdayNumberFromName(b.weekDayKey)
  })
}
